import { Headline, Stack, Tag } from '@servicetitan/design-system';

type DrawerHeaderProps = {
  title: string;
  count: number;
};

const DrawerHeader = ({ count, title }: DrawerHeaderProps) => {
  return (
    <Stack spacing={1} alignItems='center'>
      <Headline className='m-b-0'>{title}</Headline>
      <Tag badge compact>
        {count}
      </Tag>
    </Stack>
  );
};

export default DrawerHeader;
